"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const shared_styles_1 = require("../common/shared-styles");
const Link_1 = require("../Link");
const StyledButton = (0, styled_components_1.default)(ButtonBase_1.default) `
  ${shared_styles_1.baseButtonStyles};
  color: ${({ theme }) => theme.palette.primary.main};
  position: relative;

  ${Link_1.linkStyles}

  &:disabled {
    ${shared_styles_1.disabledButtonStyles};
    outline: none;
    pointer-events: auto;
    text-decoration: none;
  }
`;
/**
 * _Text Button_
 *
 * Inherits the styles of Link but behaves like a button.
 *
 */
const TextButton = (props) => ((0, jsx_runtime_1.jsx)(StyledButton, { ...props, disableRipple: true }));
exports.default = TextButton;
//# sourceMappingURL=index.js.map